export interface SameShelfSetting {
  _id: string;
  date: string;
  manufacturer: string;
  manufacturer_name: string;
  country: string;
  country_name: string;
  category: string;
  category_name: string;
  adjacency: any[];
}

export const same_shelf_setting_default = {
  _id: "",
  date: "",
  manufacturer: "",
  manufacturer_name: "",
  country: "",
  country_name: "",
  category: "",
  category_name: "",
  same_shelf: Array({
    regions: [],
    channels: [],
    outlet_classes: [],
    retailers: [],
    identifier_type: [],
    identifier_id: [],
    points: [0],
    type: [],
  }),
};

export interface SameShelfSettingDetailFormData {
  _id: string;
  date: string;
  manufacturer: string;
  manufacturer_name: string;
  country: string;
  country_name: string;
  category: string;
  category_name: string;
  same_shelf: Array<{
    regions: string[];
    channels: string[];
    outlet_classes: string[];
    retailers: string[];
    identifier_type: string[];
    identifier_id: any[];
    points: number[];
    type: string[];
  }>;
}

export interface SameShelfSettingUpdateProps {
  date: string;
  _id: string;
  manufacturer: string;
  country: string;
  category: string;
  same_shelf: any[];
}

export const updateParams = (params: SameShelfSettingUpdateProps) => {
  return {
    _id: params._id,
    date: params.date,
    manufacturer: params.manufacturer,
    country: params.country,
    category: params.category,
    same_shelf: params.same_shelf,
  };
};
